import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_dashboard/partners/")({
  beforeLoad: () => {
    throw redirect({ to: "/partners/home" })
  },
})
